export const SIDE_BAR = {
  WIDTH: 280,
};

export const MINI_SIDE_BAR = {
  WIDTH: 85,
};

export const FOOTER_HEADER = {
  HEIGHT: 64,
};
